<template>
  <section class="manufacturing-section">
    <div class="container">
      <div class="section-header">
        <h2 class="section-title">Manufacturing Capabilities to Meet Your Needs</h2>
        <p class="section-subtitle">
          We handle custom manufacturing from first prototype to full production.
        </p>
      </div>

      <div class="services-grid">
        <div class="service-card">
          <div class="card-image" @click.stop="showDetail('cnc')">
            <img src="@/assets/images/home/1.jpg" alt="CNC Machining" style="position: relative;top:15px;width: 90%;height: 90%;"/>
            <div class="card-overlay">
              <button class="overlay-btn">Take A Closer Look</button>
            </div>
          </div>
          <div class="card-content">
            <p class="card-title">
              CNC Machining Services
              <i class="el-icon-arrow-right arrow-icon"></i>
            </p>
            <p class="card-desc">
              Tight tolerances and finishing capabilities, as fast as 2 days.
            </p>
          </div>
        </div>

        <div class="service-card">
          <div class="card-image" @click.stop="showDetail('3d-printing')">
            <img src="@/assets/images/home/2.jpg" alt="3D Printing" style="width: 98%;height: 98%;position: relative;top:22px;" />
            <div class="card-overlay">
              <button class="overlay-btn">Take A Closer Look</button>
            </div>
          </div>
          <div class="card-content">
            <p class="card-title">
              3D Printing Services
              <i class="el-icon-arrow-right arrow-icon"></i>
            </p>
            <p class="card-desc">
               SLS, SLA, Metal (SLM), MJF technologies.
            </p>
          </div>
        </div>

        <div class="service-card">
          <div class="card-image" @click.stop="showDetail('sheet-metal')">
            <img src="@/assets/images/home/3.jpg" alt="Sheet Metal" style="width: 104%;height: 104%;"/>
            <div class="card-overlay">
              <button class="overlay-btn">Take A Closer Look</button>
            </div>
          </div>
          <div class="card-content">
            <p class="card-title">
              Sheet Metal Services
              <i class="el-icon-arrow-right arrow-icon"></i>
            </p>
            <p class="card-desc">
              Experience the versatility & cost efficiency with flexible application options.
            </p>
          </div>
        </div>

        <div class="service-card">
          <div class="card-image" @click.stop="showDetail('compression-molding')">
            <img src="@/assets/images/home/4.jpg" alt="Compression Molding" style="width: 80%;height: 80%;position: relative;top: 12px;" />
            <div class="card-overlay">
              <button class="overlay-btn">Take A Closer Look</button>
            </div>
          </div>
          <div class="card-content">
            <p class="card-title">
              Compression Molding Services
              <i class="el-icon-arrow-right arrow-icon"></i>
            </p>
            <p class="card-desc">
              Experience lower tooling costs with high-quality durable parts.
            </p>
          </div>
        </div>

        <div class="service-card">
          <div class="card-image" @click.stop="showDetail('die-casting')">
            <img src="@/assets/images/home/5.jpg" alt="Die Casting" style="width: 92%;height: 92%;position: relative;top: 10px;" />
            <div class="card-overlay">
              <button class="overlay-btn">Take A Closer Look</button>
            </div>
          </div>
          <div class="card-content">
            <p class="card-title">
              Die Casting Services
              <i class="el-icon-arrow-right arrow-icon"></i>
            </p>
            <p class="card-desc">
              Create high quality custom mechanicals with precision and accuracy.
            </p>
          </div>
        </div>
      </div>

      <div class="cta-wrapper">
        <button class="cta-button" @click="$router.push('/quote')">
          Get Instant Quote
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>

    <div class="modal-overlay" v-if="dialogVisible" @click.self="closeDetail">
      
      <button class="modal-close desktop-close" @click="closeDetail"></button>

      <div class="modal-container">
        
        <div class="modal-tabs desktop-tabs">
          <button v-for="tab in tabs" :key="tab.key" class="tab-btn" :class="{ active: currentTab === tab.key }"
            @click="switchTab(tab.key)">
            {{ tab.label }}
          </button>
        </div>

        <div class="modal-content">
          
          <button class="modal-close mobile-close" @click="closeDetail"></button>

          <div class="mobile-tabs-dropdown" :class="{ 'dropdown--open': isDropdownOpen }">
            <div class="dropdown-trigger" @click="isDropdownOpen = !isDropdownOpen">
              <span>{{ currentTabLabel }}</span>
              <svg class="dropdown-arrow" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <polyline points="6 9 12 15 18 9"></polyline>
              </svg>
            </div>
            <transition name="fade-down">
              <div class="dropdown-menu" v-show="isDropdownOpen">
                <div v-for="tab in tabs" :key="tab.key" 
                     class="dropdown-item" 
                     :class="{ active: currentTab === tab.key }"
                     @click="selectMobileTab(tab.key)">
                  {{ tab.label }}
                  <svg v-if="currentTab === tab.key" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#16bc9c" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <polyline points="20 6 9 17 4 12"></polyline>
                  </svg>
                </div>
              </div>
            </transition>
          </div>

          <div class="modal-top-link-wrapper">
            <a href="#" class="modal-top-link">
              See all {{ currentDetail.shortName }} Services
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                stroke-linecap="round" stroke-linejoin="round" style="margin-left: 4px; vertical-align: middle;">
                <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path>
                <path d="M15 3h6v6"></path>
                <path d="M10 14 21 3"></path>
              </svg>
            </a>
          </div>

          <div class="modal-header-content">
            <h3 class="modal-title">{{ currentDetail.title }}</h3>
            <p class="modal-subtitle">{{ currentDetail.subtitle }}</p>
          </div>

          <div class="modal-body">
            <div class="modal-left">
              <div class="modal-img-wrapper">
                <img :src="currentDetail.image" alt="" class="modal-image" :style="currentDetail.imgStyle" />
              </div>
            </div>
            <div class="modal-right">
              <ul class="modal-features">
                <li v-for="(item, index) in currentDetail.features" :key="index">
                  <span class="icon-wrapper">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#16bc9c" stroke-width="2">
                      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
                    </svg>
                  </span>
                  {{ item }}
                </li>
              </ul>
              <button class="modal-quote-btn" @click="$router.push('/quote')">Get Instant Quote</button>
            </div>
          </div>

          <div class="modal-footer-stats">
            <div class="stat-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#16bc9c">
                <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"></path>
              </svg>
              <span>95.4% of orders delivered on-time and to-spec</span>
            </div>
            <div class="stat-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#16bc9c">
                <path
                  d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z">
                </path>
              </svg>
              <span>Trusted by over 3,500 companies</span>
            </div>
            <div class="stat-item">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="#16bc9c">
                <path
                  d="M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.98l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z">
                </path>
              </svg>
              <span>30M+ parts manufactured</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Manufacturing_Capabilities_Section',
  data() {
    return {
      dialogVisible: false,
      isDropdownOpen: false, 
      currentDetail: {
        title: '',
        subtitle: '',
        shortName: '',
        features: [],
        stats: '',
        trust: '',
        image: ''
      },
      currentTab: 'cnc',
      tabs: [
        { key: 'cnc', label: 'CNC Machining' },
        { key: '3d-printing', label: '3D Printing' },
        { key: 'sheet-metal', label: 'Sheet Metal' },
        { key: 'die-casting', label: 'Die Casting' },
        { key: 'compression-molding', label: 'Compression Molding' }
      ],
      serviceDetails: {
        'cnc': {
          title: 'CNC Machining',
          subtitle: 'Tight tolerances and finishing capabilities, as fast as 2 days.',
          shortName: 'CNC Machining',
          features: [
            'Parts delivered in as quickly as 2 days',
            'Milling, Turning, EDM, and Gear Hobbing processes available',
            'Over 45+ certified materials and 13+ finishing options',
            '+/- 0.0025mm tolerance for metals, PEEK, and ULTEM with drawing',
            'ISO 9001 certified, with partners certified to AS 9100, ISO 13485, and IATF 16949'
          ],
          stats: '95.4% of orders delivered on-time and to-spec',
          trust: 'Trusted by over 3,500 companies',
          image: require('@/assets/images/home/1.jpg'),
          imgStyle: 'position:relative;top:8px;'
        },
        '3d-printing': {
          title: '3D Printing',
          subtitle: ' SLS, SLA, Metal (SLM), MJF technologies.',
          shortName: '3D Printing',
          features: [
            'Parts delivered in as fast as 24 hours',
            'SLS, SLA, Metal (SLM), MJF',
            'Over 45+ material and finishing options',
            'One partner from prototyping to production',
            'DFM feedback as soon as you upload your part'
          ],
          stats: '95.4% of orders delivered on-time and to-spec',
          trust: 'Trusted by over 3,500 companies',
          image: require('@/assets/images/home/2.jpg'),
          imgStyle: 'height:96%;width:96%;position:relative;top:13px;'
        },
        'sheet-metal': {
          title: 'Sheet Metal',
          subtitle: 'Experience the versatility & cost efficiency with flexible application options.',
          shortName: 'Sheet Metal',
          features: [
            'Blanking, bending, insert installation, and secondary finishing options available',
            'Over 27+ material and finishing options',
            '+/- 0.1mm tolerance with drawing',
            'ISO 9001 certified',
            'Domestic and overseas lead time options available'
          ],
          stats: '95.4% of orders delivered on-time and to-spec',
          trust: 'Trusted by over 3,500 companies',
          image: require('@/assets/images/home/3.jpg'),
          imgStyle: 'width:130%;height:130%;'
        },
        'die-casting': {
          title: 'Die Casting',
          subtitle: 'Create high quality custom mechanicals with precision and accuracy.',
          shortName: 'Die Casting',
          features: [
            'ISO 9001 certified, with partners certified to AS 9100 and ISO 13485',
            '14+ material and finishing options',
            'Linear dimension tolerance +/- 0.01mm with drawing',
            'Hardware installation and mechanical assembly available',
            'Part inspection reports included with every order'
          ],
          stats: '95.4% of orders delivered on-time and to-spec',
          trust: 'Trusted by over 3,500 companies',
          image: require('@/assets/images/home/5.jpg'),
          imgStyle: 'width:92%;height:92%;position:relative;top:10px;'
        },
        'compression-molding': {
          title: 'Compression Molding',
          subtitle: 'Experience lower tooling costs with high-quality durable parts.',
          shortName: 'Compression Molding',
          features: [
            'ISO 9001 certified, with partners certified to AS 9100 and ISO 13485',
            '14+ material and finishing options',
            'Linear dimension tolerance +/- 0.01mm with drawing',
            'SPI polished finishes and MT textured finishes available',
            'Pad printing and color matching available'
          ],
          stats: '95.4% of orders delivered on-time and to-spec',
          trust: 'Trusted by over 3,500 companies',
          image: require('@/assets/images/home/4.jpg'),
          imgStyle: 'width:80%;height:80%;position:relative;top:12px;'
        }
      },
    };
  },
  computed: {
    currentTabLabel() {
      const tab = this.tabs.find(t => t.key === this.currentTab);
      return tab ? tab.label : '';
    }
  },
  methods: {
    showDetail(serviceKey) {
      const detail = this.serviceDetails[serviceKey];
      if (detail) {
        this.currentDetail = detail;
        this.currentTab = serviceKey;
        this.isDropdownOpen = false;
        this.dialogVisible = true;
      }
    },
    closeDetail() {
      this.dialogVisible = false;
      this.isDropdownOpen = false;
    },
    switchTab(tabKey) {
      if (this.serviceDetails[tabKey]) {
        this.currentDetail = this.serviceDetails[tabKey];
        this.currentTab = tabKey;
      }
    },
    selectMobileTab(tabKey) {
      this.switchTab(tabKey);
      this.isDropdownOpen = false; 
    }
  }
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.manufacturing-section {
  background-color: #f4f4f4;
  padding: 60px 20px;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;
}

.container {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;
}

.section-header {
  text-align: center;
  width: 100%;
}

.section-title {
  font-size: 33px;
  color: #333;
  margin: 0 0 10px;
  font-weight: 600;
  line-height: 1.2;
}

.section-subtitle {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
  max-width: 800px;
  margin: 0 auto;
}

.services-grid {
  width: 100%;
  max-width: 960px;
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 24px;
}

.service-card {
  width: 298px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.card-image {
  position: relative;
  height: 280px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
}

.card-image img {
  width:90%;
  height: 90%;
  object-fit: cover;
  display: block;
}

.card-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  background-color: rgba(0, 0, 0, 0.05);
}

.service-card:hover .card-overlay {
  opacity: 1;
  cursor: pointer;
}

.overlay-btn {
  background-color: rgb(0, 123, 98);
  color: #fff;
  border: none;
  padding: 12px 28px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
}

.card-content {
  padding: 24px 13px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #222;
  margin: 0 0 14px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: default;
}

.arrow-icon {
  font-size: 12px;
  color: #131313;
  font-weight: 600;
  position: relative;
  top: 2px;
  right: 5px;
}

.card-desc {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.cta-wrapper {
  width: 100%;
  text-align: center;
}

.cta-button {
  background-color: #16bc9c;
  color: #fff;
  border: none;
  padding: 16px 32px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.25s ease;
  cursor: pointer;
}

.cta-button:hover {
  background-color: #03997b;
}

/* ========================================================
   弹窗整体样式 (桌面端基础样式，不变)
   ======================================================== */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 1080px; 
  padding: 0 20px;   
}

/* 顶部标签 (桌面端) */
.desktop-tabs {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 4px 6px;
  background-color: #f0f0f0;
  border-radius: 24px;
  width: 100%;
  max-width: 100%;
  margin-bottom: 16px;
  overflow-x: auto; 
  white-space: nowrap; 
  -webkit-overflow-scrolling: touch; 
}

.desktop-tabs::-webkit-scrollbar {
  display: none;
}
.desktop-tabs {
  -ms-overflow-style: none;
  scrollbar-width: none;
}

.tab-btn {
  border: none;
  background: transparent;
  color: #555;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.25s ease;
  text-align: center;
  flex-shrink: 0; 
}

.tab-btn:hover {
  background: #e8e8e8;
}

.tab-btn.active {
  background: #16bc9c;
  color: #fff;
  font-weight: 500;
}

/* 移动端 Dropdown 默认隐藏 */
.mobile-tabs-dropdown {
  display: none;
}

/* 白色弹窗核心容器 */
.modal-content {
  width: 100%; 
  background: #fff;
  border-radius: 8px;
  position: relative;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.2);
  animation: fadeIn 0.2s ease;
  padding: 32px 54px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-height: calc(100vh - 120px); 
  overflow-y: auto; 
}

/* 独立关闭按钮 */
.modal-close {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid #000;
  position: absolute;
  top: 25px;
  right: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  z-index: 10;
  transition: background-color 0.2s;
}
.modal-close:hover {
  background: #f0f0f0;
}

.modal-close::before,
.modal-close::after {
  content: '';
  position: absolute;
  width: 16px;
  height: 2px;
  background: #000;
}
.modal-close::before { transform: rotate(45deg); }
.modal-close::after { transform: rotate(-45deg); }

.desktop-close { display: flex; }
.mobile-close { display: none; }

/* 第一层级：See all 链接 */
.modal-top-link-wrapper {
  align-self: flex-end;
  width: auto;
}

.modal-top-link {
  display: inline-block;
  color: #16bc9c;
  text-decoration: none;
  font-weight: 600;
  font-size: 16px;
  line-height: 1.2;
}

.modal-top-link svg {
  color: inherit;
  margin-left: 4px;
  vertical-align: middle;
}

/* 第二层级：title + subtitle */
.modal-header-content {
  margin-bottom: 16px;
}

.modal-title {
  font-size: 24px;
  color: #222;
  margin: 0 0 8px;
  font-weight: 600;
}

.modal-subtitle {
  font-size: 15px;
  color: #555;
  margin: 0;
}

/* 第三层级：图片 + 功能列表 */
.modal-body {
  display: flex;
  gap: 24px;
  flex: 1;
  align-items: flex-start;
}

.modal-left { width: 40%; }
.modal-right { width: 60%; }

.modal-img-wrapper {
  position: relative;
  background: #fff;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 280px;
}

.modal-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.modal-features {
  list-style: none;
  padding: 0;
  margin: 0 0 28px;
}

.modal-features li {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 8px 0;
  border-bottom: 1px solid #eee;
  font-size: 14px;
  color: #333;
  line-height: 1.5;
}

.icon-wrapper {
  margin-top: 2px;
}

.modal-quote-btn {
  background-color: #16bc9c;
  color: #fff;
  border: none;
  padding: 14px 36px;
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.25s;
}

.modal-quote-btn:hover {
  background-color: #03997b;
}

/* 第四层级：底部统计栏（电脑端） */
.modal-footer-stats {
  display: flex;
  justify-content: center;
  gap: 40px;
  padding: 16px 0;
  background: #f8fdfb;
  border-radius: 4px;
  margin-top: 16px;
}

.stat-item {
  display: flex;
  align-items: flex-start; 
  gap: 8px;
  font-size: 14px;
  color: #333;
  line-height: 1.5; 
}

.stat-item svg {
  flex-shrink: 0; 
  margin-top: 1px; 
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* ★ 修改后的下拉动画：展开有动画，收起无动画瞬间完成 */
.fade-down-enter-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}
.fade-down-leave-active {
  transition: none; /* 瞬间收起防止推移卡顿 */
}
.fade-down-enter-from {
  opacity: 0;
  transform: translateY(-5px);
}
.fade-down-leave-to {
  display: none;
}

/* ========================================================
   响应式断点适配 (针对白色弹窗及内部排版)
   ======================================================== */

@media (max-width: 1023px) {
  .desktop-tabs, .desktop-close {
    display: none;
  }
  .modal-top-link-wrapper {
    display: none;
  }

  .mobile-close {
    display: flex;
    top: 16px;
    right: 16px;
    border: none;
    background: transparent;
  }
  .mobile-close::before, .mobile-close::after {
    background: #333;
  }

  .mobile-tabs-dropdown {
    display: block;
    position: relative;
    width: 100%;
    margin-bottom: 24px; 
    z-index: 20;
  }
  .dropdown-trigger {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f4f4f4; 
    padding: 14px 20px;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 600;
    color: #333;
    cursor: pointer;
  }
  .dropdown-arrow {
    transition: transform 0.3s ease;
  }
  .dropdown--open .dropdown-arrow {
    transform: rotate(180deg);
  }
  .dropdown-menu {
    position: relative; 
    width: 100%;
    background: #fff;
    border-radius: 6px;
    margin-top: 8px;
    border: 1px solid #ebebeb;
    overflow: hidden;
  }
  .dropdown-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 14px 20px;
    font-size: 15px;
    color: #555;
    cursor: pointer;
    border-bottom: 1px solid #f2f2f2;
    transition: background 0.2s;
  }
  .dropdown-item:last-child {
    border-bottom: none;
  }
  .dropdown-item.active {
    color: #16bc9c;
    background: #f8fdfb;
    font-weight: 600;
  }

  .modal-content {
    padding: 60px 24px 24px 24px; 
    max-height: calc(100vh - 80px); 
  }
  
  .modal-body {
    flex-direction: column;
    gap: 20px;
  }
  .modal-left, .modal-right {
    width: 100%;
  }

  .modal-img-wrapper {
    height: auto; 
    min-height: 200px;
    aspect-ratio: 16 / 9;
    background: transparent;
  }
  .modal-image {
    width: 100% !important;
    height: 100% !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    bottom: 0 !important;
    object-fit: contain !important; 
    transform: none !important;
  }
  
  .modal-footer-stats {
    flex-direction: column; 
    align-items: flex-start; 
    gap: 12px;               
    padding: 20px;           
  }
  .stat-item {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 767px) {
  .modal-container {
    padding: 0 10px; 
  }
  .modal-content {
    padding: 56px 16px 20px 16px; 
  }
  .mobile-close {
    top: 12px;
    right: 12px;
    width: 30px;
    height: 30px;
  }
  .modal-title {
    font-size: 20px;
  }
  .modal-subtitle {
    font-size: 14px;
  }
  .modal-img-wrapper {
    aspect-ratio: 4 / 3; 
  }
  .modal-quote-btn {
    width: 100%; 
  }
  .dropdown-trigger {
    font-size: 15px;
    padding: 12px 16px;
  }
}
</style>